module.exports = __webpack_public_path__ + "img/background-gray-lightgray.60d0bb64.png";